
function Loading()
{
    return(
        <div className="overflow-y-hidden  overflow-x-hidden  " style={{/* backgroundColor:'#e8e8e8', */marginTop:'10rem',marginLeft:'30rem'}}>
            <div  className="loader"></div>
        </div>
    );
}
export default Loading